import React, { createContext, useState, useContext } from "react";

const StateContext = createContext();

export const StateProvider = ({ children }) => {
  const [changeBgColor, setChangeBgColor] = useState("#ffffff");
  const [currentUrl, setCurrentUrl] = useState("");
  const [currentCardTitle, setCurrentCardTitle] = useState("");

  return (
    <StateContext.Provider
      value={{
        changeBgColor,
        setChangeBgColor,
        currentUrl,
        setCurrentUrl,
        setCurrentCardTitle,
        currentCardTitle,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export const useStateContext = () => useContext(StateContext);
